import axios from "axios";

const API_URL = "https://backend.reportingbot.in/api/ecg/vendor-dashboard/";

/**
 * Fetches the ECG vendor dashboard data.
 *
 *   getECGVendorDashboard()                      -> page 1, page_size 10, no filters
 *   getECGVendorDashboard({ status:"pending" }, 2) -> page 2 with a status filter
 */
export const getECGVendorDashboard = async (filters = {}, page = 1, pageSize = 50) => {
  const params = {};

  if (filters.customer) params.customer = filters.customer;
  if (filters.search) params.search = filters.search;
  if (filters.status) params.status = filters.status;
  if (filters.gender) params.gender = filters.gender;
  if (filters.test_date) params.test_date = filters.test_date;

  params.page = page;
  params.page_size = pageSize;

  const response = await axios.get(API_URL, {
    params,
    withCredentials: true,
  });

  return response.data;
};

export default { getECGVendorDashboard };